<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >
    <b-card
      border-variant="secondary"
      class="text-center mt-5"
    >
      <div class="col-sm-12">
        <h1 class="h1cimke">Munkalap</h1>
        <div class="row">

          <div v-if="userType=='admin' || userType=='user'" class="col-sm-4">
            <!-- // NEW -->
            <b-button
              size="sm"
              variant="primary"
              class="btn float-left"
              @click="$router.push({ name: 'MunkalapNew' })"
              ><b-icon-plus-circle></b-icon-plus-circle>
              Új munkalap hozzáadása
            </b-button>
          </div>

          <!-- // SEARCH INPUT -->
          <div>
            <b-button-group>
              <b-button
                size="sm"
                class="btn float-left"
                variant="outline-danger"
                @click="searchText='', filterSelect='', search()"
                ><b-icon-x-circle></b-icon-x-circle>
              </b-button>

              <b-form-select
                size="sm"
                v-model="filterSelect"
                :options="filters"
                class="form-control"
                id="td"
                required
              ></b-form-select>
            </b-button-group>
          </div>

          <div class="col-sm-2">
            <b-form-input
              size="sm"
              class="form-control"
              ref="searchInput"
              v-model="searchText"
              id="search"
              @click="searchText=''"
              @keyup.enter="search()"
              autofocus
            ></b-form-input>
          </div>

          <div>
            <b-button
              size="sm"
              class="btn float-left"
              variant="success"
              @click="search()"
              ><b-icon-search></b-icon-search>
              Keresés
            </b-button>
          </div>

        </div>

      </div>

      <!-- // TABLE -->
      <div class="mt-3">
        <b-table class="labelsize table-striped" hover :items="list" :fields="fields" :key="list.id">

          <!-- // PDF -->
          <template v-slot:cell(munkalap)="row" class="mb-1">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="
                $router.push({
                  name: 'Munkalap',
                  params: { id: row.item.id }
                })
              "
              class="mr-0"
              >
              <img style="width: 14px;" src="../assets/pdf-icon.png" alt="">
            </b-button>
          </template>

          <!-- // PRINT PDF -->
          <template v-slot:cell(print)="row" class="mb-1">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="printPDF(row.item.id)"
              class="mr-0"
              >
              <b-icon-printer></b-icon-printer>
            </b-button>
          </template>

          <!-- // EDIT -->
          <template v-if="userType=='admin' || userType=='user'" v-slot:cell(edit)="row">
            <b-button v-if="row.item.closed != 1"
              size="sm"
              @click="
                $router.push({
                  name: 'MunkalapNew',
                  params: { id: row.item.id }
                })
              "
              variant="outline-success"
              class="mr-0"
            ><b-icon-pencil></b-icon-pencil>
            </b-button>
            <b-button v-if="row.item.closed === 1"
              size="sm"
              @click="
                $router.push({
                  name: 'MunkalapPreview',
                  params: { id: row.item.id }
                })
              "
              variant="outline-danger"
              class="mr-0"
            ><b-icon-eye></b-icon-eye>
            </b-button>

          </template>

          <!-- // DELETE -->
          <template v-if="userType=='admin'" v-slot:cell(del)="row" class="mb-1">
            <b-button
              size="sm"
              @click="showMsgBoxTwo(row.item.id)"
              variant="outline-danger"
              class="mr-1"
              ><b-icon-trash></b-icon-trash>
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>

  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import VueHtml2pdf from 'vue-html2pdf'
import jwtDecode from 'jwt-decode'
import moment from 'moment'

export default {
  components: {
    VueHtml2pdf
  },
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      dateconvert: null,
      EgyebTetelekShow: false,
      tableHeadShow: false,
      boxTwo: '',
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      filters: [
        'Minden oszlop',
        'Megnevezés'
      ],
      list: [],
      fields: [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'bizszam',
          label: 'Bizonylatszám',
          sortable: true,
          sortDirection: 'desc',
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'datum',
          formatter: (value, key, item) => {
            return moment(String(value)).format('YYYY-MM-DD hh:mm:ss')
          },
          label: 'Dátum',
          sortable: true,
          thClass: 'text-left',
          tdClass: 'text-left'

          // sortDirection: 'desc'
        },
        {
          key: 'partner.nev',
          label: 'Beszállító',
          sortable: true,
          sortDirection: 'desc',
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'megjegyzes',
          label: 'Megjegyzés',
          sortable: true,
          sortDirection: 'desc',
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'summa',
          label: 'Végösszeg',
          sortable: true,
          sortDirection: 'desc',
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        // { key: 'send', sortable: false },
        // { key: 'munkalap', sortable: false },
        { key: 'edit',
          label: 'Részletek',
          sortable: false
        }
        // { key: 'del', sortable: false }
      ],
      myTempAnyagTipus: [],
      searchText: '',
      filterSelect: ''
    }
  },
  methods: {
    search () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.filter = this.filterSelect
        payload.searchText = this.searchText
        axios.post(process.env.ROOT_API + '/munkalap/search', {payload})
          .then(res => {
            this.list = res.data
            this.$refs.searchInput.focus()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    redirect: function (link, target = '_blank') {
      window.open(link, target)
    },
    printPDF (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios.post(process.env.ROOT_API + '/munkalap/pdf', {payload})
          .then(res => {
            this.myTempAnyagTipus = res.data.client
            if (this.myTempAnyagTipus.cikkTetels.length > 0) {
              this.EgyebTetelekShow = true
            } else { this.EgyebTetelekShow = false }
            this.$refs.html2Pdf.generatePdf()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    deleteElement: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios
          .post(process.env.ROOT_API + '/munkalap/delete', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showMsgBoxTwo (id) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('(ID:' + id + ') ', {
          title: 'Biztos törlöni akarod?',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.deleteElement(id)
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        axios.post(process.env.ROOT_API + '/munkalap/getlist', {payload})
          .then(res => {
            this.list = res.data.myMunkalap
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    this.loadList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Munkalap.vue